import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { PopulationQuery } from '@fgb/core';
import { distinctUntilChanged, fromEvent, map, startWith } from 'rxjs';

@Component({
  selector: 'fgb-games-v2-layout',
  templateUrl: './games-v2-layout.component.html',
  styleUrl: './games-v2-layout.component.scss',
})
export class GamesV2LayoutComponent implements OnInit, AfterViewInit {
  showHeader: boolean = false;
  headerContent: { title: string; bannerImg: string; routeLink: string };
  isKid: boolean;
  isRulesEnabled: boolean = false;
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private populationQuery = inject(PopulationQuery);
  private cd = inject(ChangeDetectorRef);
  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._init();
      }
    });
    fromEvent(window, 'resize')
      .pipe(
        startWith(window.innerWidth < 992),
        map(() => window.innerWidth < 992),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this._checkHeaderVisibility();
      });
  }
  ngAfterViewInit(): void {
    this._init();
  }
  private _init(): void {
    this._checkHeaderVisibility();
    this.cd.detectChanges();
  }
  private _checkHeaderVisibility(): void {
    const pageWithHeader: string[] = ['trivia', 'predictor'];
    this.showHeader = pageWithHeader.some((path) => this.router.url.includes(path));
    if (this.router.url.includes('trivia')) {
      this.headerContent = { title: 'games.page.trivia.title', bannerImg: 'banner-images/trivia-banner.png', routeLink: 'trivia' };
    }
    if (this.router.url.includes('predictor')) {
      this.headerContent = {
        title: 'games.page.predictor.title',
        bannerImg: 'banner-images/predictor-banner.png',
        routeLink: 'predictor',
      };
    }
  }
}
